const externalUrl = url => url.indexOf('/') !== 0;

export { externalUrl };
